import { sendMessageUseCase } from '@/domain/use-cases/send-message.use-case';
import { Result } from '@/entities';
import { SendMessageData, SendMessagePayload } from '@/entities/sendMessageData';

export const sendMessageController = async (
	teamLeagueUuid: string,
	organizationUuid: string,
	requestPayload: SendMessagePayload
): Promise<Result<SendMessageData>> => {
	return sendMessageUseCase(teamLeagueUuid, organizationUuid, requestPayload);
};
